<template>
    <div class="container">

        <div class="product_container product_container__big">


            <div class="catalog-sec__control-row">

                <h3 class="category-title" id="search_q">{{ trans('Search') }} : {{ search }} </h3>

            </div>

                <template v-for="(cards,gender) in contents">
                    <div class="catalog-sec__control-row">
                        <h3 class="category-title" id="search_q">{{trans(gender)}}</h3>
                    </div>
                     <div class="product-row">
                        <template v-for="(card, cardIndex) in cards" :key="card.id">
                            <product-card
                                :card="card"
                                :item-list-id="'search_' + gender"
                                :item-list-name="'Search ' + gender"
                                :index="cardIndex + 1"
                            />
                        </template>
                    </div>
                </template>

        </div>
    </div>
</template>

<script>
import ProductCard from '../../components/product-card.vue'
import { viewItemList } from '../../services/ga4Ecommerce.js'
export default {
    components:{
        ProductCard
    },
    name: "index",
    mounted() {
        this.getSearch()
        this.$parent.$refs.header.search = this.search
    },
    data(){
        return{
            contents:{},
            search : new URLSearchParams(document.location.search).get('search')
        }
    },
    methods:{
        async getSearch(){
            const params = { search: this.search }
            const gender = new URLSearchParams(document.location.search).get('gender')
            if (gender) {
                params.gender = gender;
            }
            await  axios.get('/api/v1/search', {
                params:this.setParam(params)})
                .then(data =>{
                    for (var gender in data.data) {
                        this.contents[gender] = data.data[gender].sort((a, b) => (a.sort < b.sort) ? 1 : -1);
                        this.contents[gender] = this.contents[gender].filter(item => {
                            if(item.images.length > 0){
                                return item;
                            }
                        })
                        viewItemList(this.contents[gender], 'search_' + gender, 'Search ' + gender)
                    }
                })

        }
    }
}
</script>

<style scoped>

</style>
